(() => {
  const el = document.querySelector('[data-sticky-logo-overlay]');
  if (!el) return;

  const getStr = (name) => (el.getAttribute(name) || '').trim();
  const getNum = (name, fallback = 0) => {
    const v = parseInt(getStr(name), 10);
    return Number.isFinite(v) ? v : fallback;
  };

  const startSelector = getStr('data-start-selector');
  const endSelector = getStr('data-end-selector');
  const startMode = (getStr('data-start-mode') || 'section').toLowerCase();
  const endMode = (getStr('data-end-mode') || 'section').toLowerCase();
  const startOffset = getNum('data-start-offset', 0);

  // Responsive end offsets
  const endOffsetMobile = getNum('data-end-offset-mobile', -35);
  const endOffsetDesktop = getNum('data-end-offset-desktop', -80);
  const desktopBp = getNum('data-desktop-breakpoint', 990);

  let startEl = null;
  let endEl = null;

  const resolve = () => {
    startEl = startSelector ? document.querySelector(startSelector) : null;
    endEl = endSelector ? document.querySelector(endSelector) : null;
  };

  const boundaryFrom = (node, mode) => {
    if (!node) return null;
    if (mode === 'marker') return node;
    return node.closest('.shopify-section') || node;
  };

  const currentEndOffset = () => (window.innerWidth >= desktopBp ? endOffsetDesktop : endOffsetMobile);

  const hide = () => {
    el.classList.remove('is-visible', 'is-parked');
    el.style.position = '';
    el.style.left = '';
    el.style.top = '';
    el.style.transform = '';
  };

  const showFixedCentered = () => {
    el.classList.add('is-visible');
    el.classList.remove('is-parked');
    el.style.position = 'fixed';
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.transform = 'translate(-50%, -50%)';
  };

  const parkCenteredAt = (centerDocY, logoH) => {
    const topDocY = centerDocY - (logoH / 2);
    el.classList.add('is-visible', 'is-parked');
    el.style.position = 'absolute';
    el.style.left = '50%';
    el.style.top = `${Math.max(0, topDocY)}px`;
    el.style.transform = 'translateX(-50%)';
  };

  const update = () => {
    resolve();
    if (!endEl) {
      hide();
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset;
    const vh = window.innerHeight;

    const startBoundary = startEl ? boundaryFrom(startEl, startMode) : null;
    const endBoundary = boundaryFrom(endEl, endMode);
    if (!endBoundary) {
      hide();
      return;
    }

    // Activate once viewport center passes start boundary
    let active = true;
    if (startBoundary) {
      const r = startBoundary.getBoundingClientRect();
      const startDocTop = scrollY + r.top + startOffset;
      active = (scrollY + (vh * 0.5)) >= startDocTop;
    }
    if (!active) {
      hide();
      return;
    }

    el.classList.add('is-visible');

    // Measure logo
    const logoH = el.getBoundingClientRect().height;

    // End boundary top in doc coords (+ responsive offset)
    const endR = endBoundary.getBoundingClientRect();
    const endDocTop = scrollY + endR.top + currentEndOffset();

    // Fixed center in doc coords
    const fixedCenterDocY = scrollY + (vh / 2);

    // Park when center would pass end boundary
    if (fixedCenterDocY >= endDocTop) {
      parkCenteredAt(endDocTop, logoH);
    } else {
      showFixedCentered();
    }
  };

  const rafUpdate = () => requestAnimationFrame(update);
  window.addEventListener('scroll', rafUpdate, { passive: true });
  window.addEventListener('resize', rafUpdate);

  const img = el.querySelector('img');
  if (img && !img.complete) img.addEventListener('load', update);

  update();
})();